/**
 * Куда ведёт уведомление по клику.
 *
 * `action_url` теперь бывает и внешним: напоминание об одной зависшей заявке
 * ведёт прямо в её карточку в CRM обменника. Отдать такой адрес в `navigate()`
 * значит попросить роутер найти маршрут `https:/crm...` внутри SPA — человек
 * получил бы пустой экран вместо заявки.
 *
 * Внутренние адреса приходят с префиксом `/erp/`, который BrowserRouter уже
 * добавляет сам через basename — иначе получается `/erp/erp/...`.
 */
export function openNotificationTarget(actionUrl, navigate) {
    if (!actionUrl) return
    if (/^https?:\/\//i.test(actionUrl)) {
        window.open(actionUrl, '_blank', 'noopener,noreferrer')
        return
    }
    navigate(actionUrl.startsWith('/erp/') ? actionUrl.slice(4) : actionUrl)
}
